import { useMemo } from 'react';
import styled from 'styled-components';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { ButtonWithBranding } from '../ButtonWithBranding';
import { getPageThumbnailStyles } from '../../utils/getPageThumbnailStyles';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const thumbnailBaseStyles = theme => ({
  marginBlockEnd: theme.space[200],
  transition: 'border-color 300ms ease',
  height: '100px',
  borderStyle: 'solid',
  borderWidth: '3px',
  borderColor: theme.color['border-core-on-fill-default'],
  boxSizing: 'content-box'
});
const ThumbnailImage = styled.img.withConfig({
  displayName: "ViewPageDrawerItem__ThumbnailImage"
})(({
  theme: _theme,
  extraStyles
}) => {
  const theme = _theme;
  return Object.assign({}, thumbnailBaseStyles(theme), {
    width: 'auto'
  }, extraStyles);
});
const ThumbnailPlaceholder = styled.div.withConfig({
  displayName: "ViewPageDrawerItem__ThumbnailPlaceholder"
})(({
  theme: _theme,
  extraStyles
}) => {
  const theme = _theme;
  return Object.assign({}, thumbnailBaseStyles(theme), {
    aspectRatio: '1 / 1',
    backgroundColor: theme.color['fill-surface-raised']
  }, extraStyles);
});
const ViewPageDrawerItem = ({
  imageUrl,
  selected,
  index,
  onClick,
  brandingColor
}) => {
  const imgStyles = useMemo(() => {
    return getPageThumbnailStyles(selected, brandingColor);
  }, [selected, brandingColor]);
  return /*#__PURE__*/_jsx(ButtonWithBranding, {
    margin: "200",
    onClick: onClick,
    tabIndex: selected ? 1 : 0,
    "aria-label": I18n.text('a11y.pageSelectorButton', {
      pageNumber: index + 1
    }),
    hasBorder: false,
    isTransparentOnHover: false,
    buttonPaddingInline: "0px",
    buttonPaddingBlock: "0px",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      children: [imageUrl ? /*#__PURE__*/_jsx(ThumbnailImage, {
        src: imageUrl,
        extraStyles: imgStyles
      }) : /*#__PURE__*/_jsx(ThumbnailPlaceholder, {
        extraStyles: imgStyles
      }), /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-100",
        color: "icon-core-subtle",
        children: index + 1
      })]
    })
  });
};
export default ViewPageDrawerItem;